import { toRem } from "shared/helpers";
import styled from "styled-components";

type MarginBottomProps = {
  $value?: number | string;
}

export const MarginBottom = styled.div<MarginBottomProps>`
  &:not(:last-child) {
    margin-bottom: ${props => toRem(props.$value || 16)};
  }
`